/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ReferralsNewRouteImport } from './routes/referrals/new'
import { Route as ReferralsMineRouteImport } from './routes/referrals/mine'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsNewRoute = ReferralsNewRouteImport.update({
  id: '/referrals/new',
  path: '/referrals/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsMineRoute = ReferralsMineRouteImport.update({
  id: '/referrals/mine',
  path: '/referrals/mine',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/referrals/mine': typeof ReferralsMineRoute
  '/referrals/new': typeof ReferralsNewRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/referrals/mine': typeof ReferralsMineRoute
  '/referrals/new': typeof ReferralsNewRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/referrals/mine': typeof ReferralsMineRoute
  '/referrals/new': typeof ReferralsNewRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/referrals/mine' | '/referrals/new' | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/referrals/mine' | '/referrals/new' | '/admin'
  id: '__root__' | '/' | '/referrals/mine' | '/referrals/new' | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ReferralsMineRoute: typeof ReferralsMineRoute
  ReferralsNewRoute: typeof ReferralsNewRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals/new': {
      id: '/referrals/new'
      path: '/referrals/new'
      fullPath: '/referrals/new'
      preLoaderRoute: typeof ReferralsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals/mine': {
      id: '/referrals/mine'
      path: '/referrals/mine'
      fullPath: '/referrals/mine'
      preLoaderRoute: typeof ReferralsMineRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ReferralsMineRoute: ReferralsMineRoute,
  ReferralsNewRoute: ReferralsNewRoute,
  AdminIndexRoute: AdminIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
